  
  window.addEventListener("quiz_initialized", (event) => {
    let progressData = event.detail.split("_");
    handleText(progressData[3]);
  });

  window.addEventListener("quiz_progress", (event) => {
    let progressData = event.detail.split("_");
    const componentId = progressData[3];
    handleCoverImage(componentId);
    handleText(componentId);
  });

  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  const setCustomBgForQuizContainer = (color) =>{
    const container = document.querySelector(".quiz-container");
    container.style.backgroundColor=color;
  }

  const handleText = (qId) =>{
    removeElement("#tangent-quiz-terms");
    removeElement("#tangent-email-disclaimer");
    setCustomBgForQuizContainer("#ffffff");
    if(qId==="682b03b3d0b7ac83c387ef57"){
      setCustomBgForQuizContainer("#f6f6f6");
      setTimeout(function() {setWelcomeScreenCustomContent()}, 1000);
    }
    else if(qId==="682f0d88d0b7ac83c38aa93e"){
      setTimeout(function() {setEmailScreenTermsContent()}, 1000);
    }
  }

  const setEmailScreenTermsContent = () =>{
    // Reference element
    const reference = document.querySelector(".tangent_survey_next_button_custom");
    
    // Create the container
    const container = document.createElement('div');
    container.id="tangent-email-disclaimer"
    container.classList.add('txxt_ct2', 'tangent-email-disclaimer');
    container.innerHTML = `<p>By submitting, you agree to receive occasional emails from No Nothing, including your personalized product recommendations.</p>`;
    
    // Insert after the reference element
    if (reference && reference.parentNode) {
      reference.parentNode.insertBefore(container, reference.nextSibling);
    }
  
  }

  const removeElement = (identifier) => {
    const element = document.querySelector(identifier);
    if(element){
      element.remove();
    }
  }

  const setWelcomeScreenCustomContent = () =>{
    const componentBlock = document.querySelector(".tangent_welcome_screen_custom");
    if(componentBlock){
      const textComponent1 = getCustomTextContent();
      componentBlock.appendChild(textComponent1); 
    }
    setCustomDisclaimerContent();
  }

  const hideElement = (identifier) =>{
    const element = document.querySelector(identifier);
    if(element){
      element.style.display="none";
    }
  }
  
  const setCustomDisclaimerContent = () =>{
     // Reference element
    const reference = document.querySelector(".tangent_quiz_container_custom");
    
    // Create the text container
    const container = document.createElement('div');
    container.id = "tangent-quiz-terms"
    container.classList.add('txxt_ct2', 'tangent-quiz-terms');
    
    // Set the inner HTML with links
    container.innerHTML = `<p>By taking this quiz, you agree to our 
      <a href="https://example.com/terms" target="_blank" style="text-decoration:underline;">Terms of Use</a> 
      and acknowledge you read our 
      <a href="https://example.com/privacy" target="_blank" style="text-decoration:underline;">Privacy Policy</a>.<p>`;
    
    // Insert after the reference element
    if (reference && reference.parentNode) {
      reference.parentNode.insertBefore(container, reference.nextSibling);
    }
  }

  const getCustomTextContent = () =>{
    // Create a flex container div
    const container = document.createElement('div');
    container.id="welcome-custom-text-content";
    
    // Create the image element
    const img = document.createElement('img');
    img.src = 'https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/23363062948807345-clock.png'; // replace with your image URL
    img.id="time-icon-welcome-screen";
    img.alt = 'icon';
    
    // Create the paragraph element
    const text = document.createElement('p');
    text.textContent = 'Takes less than 60 seconds.';
    img.classList="time-icon-text-welcome-screen";
    
    // Append image and text to container
    container.appendChild(img);
    container.appendChild(text);
    
    return container;
  }

  const handleCoverImage = (qId) =>{
    const quizBlock = document.querySelector("#tangent-main-container > div");
    const imageBlock = document.querySelector(".quiz-cover-img");
    const imageTag = document.querySelector(".quiz-cover-img > img");
    const backBtn = document.querySelector(".tangent_quiz_container_custom > button");
    
    quizBlock.style.width = "90%";
    imageBlock.style.display = "flex";
    
    if(qId==="682b03b3d0b7ac83c387ef59" || qId==="682b03b4d0b7ac83c387ef78" || qId ==="682f0d88d0b7ac83c38aa93e"){
      imageBlock.style.display = "none";
      if(!isMobileDevice()) quizBlock.style.width = "60%";
    }
    else if(qId==="682b03d1d0b7ac83c387f002"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/7089835602045247-ce6eca2b1e9a9a72a409490031160f6362493125.jpg";
    }
    else if(qId==="682b03f1d0b7ac83c387f04e"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/7013541771382674-62ed19ae58636bd72318845771610abcc744cafd.jpg";
    }
    else if(qId==="682b0424d0b7ac83c387f083"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/3980566724549792-852678b8337e059cce28dc2628fddbdc9bef684c.jpg";
    }
    else if(qId==="682b0444d0b7ac83c387f092"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/1970447172008578-4d1ad62d21ef366410626e59c660b84150cc2014.jpg";
    }
    else if(qId==="682b04b5d0b7ac83c387f0fe"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/6540943313814094-1d16ebe47c8dad416ec9b7681e2a086aeb7ef52f.png";
    }
    else if(qId==="682b04f0d0b7ac83c387f1d6"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/7467848258934056-8ab602c11097432b0c69766c035ab20dd9d6b302.jpg";
    }
    else if(qId==="682b050cd0b7ac83c387f1fc"){
      imageTag.src="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/1766792784422211-dff4f803b77170a3d078692fdf6fbccd05f65be7.jpg";
    }
    else{
      imageBlock.style.display = "flex";
      quizBlock.style.width = "unset";
    }
  }
